import React, { memo } from "react";

const CardIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M24 4.80039V19.2004C24 19.8604 23.765 20.4254 23.295 20.8954C22.825 21.3654 22.26 21.6004 21.6 21.6004H2.4C1.74 21.6004 1.175 21.3654 0.705 20.8954C0.235 20.4254 0 19.8604 0 19.2004V4.80039C0 4.14039 0.235 3.57539 0.705 3.10539C1.175 2.63539 1.74 2.40039 2.4 2.40039H21.6C22.26 2.40039 22.825 2.63539 23.295 3.10539C23.765 3.57539 24 4.14039 24 4.80039ZM2.4 7.20039H21.6V4.80039H2.4V7.20039ZM2.4 12.0004V19.2004H21.6V12.0004H2.4Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { CardIcon };
